import { API } from 'Services';

function getTrustYouProfileRequestStart(trustYouId, language) {
    return { type: 'GET_TRUST_YOU_PROFILE_REQUEST_START', payload: { trustYouId, language } };
}

function getTrustYouProfileRequestSuccess(trustYouId, response) {
    return { type: 'GET_TRUST_YOU_PROFILE_REQUEST_SUCCESS', payload: { trustYouId, response } };
}

function getTrustYouProfileRequestFailure(trustYouId) {
    return { type: 'GET_TRUST_YOU_PROFILE_REQUEST_FAILURE', payload: { trustYouId } };
}

function getTrustYouReviewsRequestStart(trustYouId, language) {
    return { type: 'GET_TRUST_YOU_REVIEWS_REQUEST_START', payload: { trustYouId, language } };
}

function getTrustYouReviewsRequestSuccess(trustYouId, response) {
    return { type: 'GET_TRUST_YOU_REVIEWS_REQUEST_SUCCESS', payload: { trustYouId, response } };
}

function getTrustYouReviewsRequestFailure(trustYouId) {
    return { type: 'GET_TRUST_YOU_REVIEWS_REQUEST_FAILURE', payload: { trustYouId } };
}

export const getTrustYouProfile = (trustYouId, language) => (dispatch, getState) => {
    const { trustYou } = getState();
    const trustYouProfile = !!trustYou[trustYouId] && trustYou[trustYouId]?.profile;
    const trustYouProfielDataAvailable = trustYouProfile && trustYouProfile?.data && trustYouProfile.language === language;

    if (trustYouProfielDataAvailable) {
        return trustYouProfile.data;
    }

    const params = {
        trustYouId,
        language,
    };

    dispatch(getTrustYouProfileRequestStart(trustYouId, language));
    return API.getTrustYouProfile(params)
        .then((response) => {
            dispatch(getTrustYouProfileRequestSuccess(trustYouId, response));
            return Promise.resolve(response);
        })
        .catch((err) => {
            dispatch(getTrustYouProfileRequestFailure(trustYouId));
            return Promise.resolve(err);
        });
};

export const getTrustYouReviews = (trustYouId, language) => (dispatch, getState) => {
    const { trustYou } = getState();
    const trustYouReviews = !!trustYou[trustYouId] && trustYou[trustYouId]?.reviews;
    const trustYouReviewsDataAvailable = trustYouReviews && trustYouReviews?.data && trustYouReviews.language === language;

    if (trustYouReviewsDataAvailable) {
        return trustYouReviews.data;
    }

    const params = {
        trustYouId,
        language,
    };

    dispatch(getTrustYouReviewsRequestStart(trustYouId, language));
    return API.getTrustYouReviews(params)
        .then((response) => {
            dispatch(getTrustYouReviewsRequestSuccess(trustYouId, response));
            return Promise.resolve(response);
        })
        .catch((err) => {
            dispatch(getTrustYouReviewsRequestFailure(trustYouId));
            return Promise.resolve(err);
        });
};
